import $ from "jquery";
import ps from "perfect-scrollbar";
export const CLIENT_ID = "2";
export const CLIENT_SECRET = "A6OmFNnpLYr5bEkODrSNjY63UwIvEClyHF5Addly";
export const API_CORREIOS = "https://viacep.com.br/ws/data/json/";
export function getUserRole() {
  var user = JSON.parse(localStorage.getItem("me"));
  return { roleID: user.roles[0].id, roleName: user.roles[0].display_name };
}
export function haveRole(roleReceived) {
  return (
    JSON.parse(localStorage.getItem("me")).roles.filter((role) => {
      return roleReceived === role.id;
    }).length > 0
  );
}
export function userIsFiscal() {
  var user = JSON.parse(localStorage.getItem("me"));
  var rolesIDs = user.roles.map((role) => {
    return role.id;
  });
  return rolesIDs.includes(4);
}
export function getUserUniOrc() {
  var user = JSON.parse(localStorage.getItem("me"));

  return user.unidade_orcamentaria.map((unidade) => {
    return unidade.id;
  });
}
export function getUserID() {
  var user = JSON.parse(localStorage.getItem("me"));
  return user.id;
}
export function getUserName() {
  var user = JSON.parse(localStorage.getItem("me"));
  return user.name;
}
export function getUserContratos() {
  var user = JSON.parse(localStorage.getItem("me"));
  return user.contratos;
}
export function getApi() {
  return localStorage.getItem("api");
}
export function getMaskNumProcesso() {
  // if (getCidade() === "Juazeiro do Norte" || getCidade() === "Barroquinha") {
  //   return ""
  // }
  return "";
}
export function getCidade() {
  return localStorage.getItem("cidade");
}
export const CITYS_API = "https://cidades.sgcontratos.com.br/api/states";
//Descomentar em produção
export const SOCKET_URL = "https://socket.sgcontratos.com.br/";
//Descomentar em desenvolvimento
// export const SOCKET_URL = 'http://192.168.10.10:9000'
export function init() {
  var isWindows = navigator.platform.indexOf("Win") > -1 ? true : false;
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    const sidebar = document.querySelector(".sidebar");
    if (sidebar !== null) ps.initialize(sidebar);

    const sidebarWrapper = document.querySelector(".sidebar-wrapper");
    if (sidebarWrapper !== null) ps.initialize(sidebarWrapper);
    const mainPanel = document.querySelector(".main-panel");
    if (mainPanel !== null) ps.initialize(mainPanel);
    $("html").addClass("perfect-scrollbar-on");
  } else {
    $("html").addClass("perfect-scrollbar-off");
  }
}



// WEBPACK FOOTER //
// ./src/constants.js